<template>
    <dashlet-card :page-href="privilegeManage ? '/administration/client' : undefined"
                  :page-tooltip="t_page_tooltip_clients"
                  :title="t_title">
        <template #append>
            <label for="append-location" aria-label="locations">
                <select v-model.number="selectedLocationId"
                        style="color: #676a6c;"
                        id="append-location">
                    <template v-for="location in locationsWithAPlan">
                        <option :value="location.id">
                            {{ location.name }}
                        </option>
                    </template>
                </select>
            </label>
        </template>

        <template #prependButton>
            <square-button :disabled="loading || noLocationSelected"
                           :loading="loading"
                           :tooltip-text="t_refresh_tooltip"
                           flat
                           icon="far fa-arrows-rotate"
                           @click="refreshPlan" />
        </template>

        <location-plan v-if="!noLocationSelected"
                       ref="locationPlan"
                       :locationId="selectedLocationId"
                       @loading="loading = $event" />

        <div v-else
             class="dashlet-message-container">
            {{ t_no_plan }}
        </div>
    </dashlet-card>
</template>

<script>
import DashletCard from './dashlet-card.vue'
import SquareButton from '../../content/common/squareButton.vue'
import LocationPlan from './clientsLocationPlan/locationPlan.vue'

export default {
    components: { LocationPlan, SquareButton, DashletCard },
    props: {
        /** @type {'1' | undefined} */
        privilegeManage: String,
        locations: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            loading: true,

            projectId: Laravel.activeProject,
            selectedLocationId: null,

            t_title: Lang.langGet('Plan for location'),
            t_page_tooltip_clients: Lang.langGet('Clients'),
            t_refresh_tooltip: Lang.langGet('Reload'),

            t_no_plan: Lang.langGet('No plan to show')
        }
    },
    computed: {
        localStorageKey() {
            return `dashlet-location-${this.projectId}`
        },
        locationsWithAPlan() {
            return this.locations.filter((location) => location.plan)
        },
        locationIdsWithAPlan() {
            return this.locationsWithAPlan.map(loc => loc.id)
        },
        noLocationSelected() {
            return this.selectedLocationId == null
        }
    },
    methods: {
        refreshPlan() {
            this.$refs.locationPlan.fetchPlan()
        }
    },
    watch: {
        selectedLocationId(val) {
            if (val != null) localStorage.setItem(this.localStorageKey, val)
        }
    },
    created() {
        let localStorageLocationId = localStorage.getItem(this.localStorageKey)
        localStorageLocationId = localStorageLocationId != null ? +localStorageLocationId : null

        this.selectedLocationId = (localStorageLocationId != null && this.locationIdsWithAPlan?.includes(localStorageLocationId)) ? localStorageLocationId : this.locationIdsWithAPlan[0]
        if (this.noLocationSelected) this.loading = false
    }
}
</script>
